var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZw(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "20px",
    viewBox: "0 0 28 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "flags / ZW") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 28,
    height: 20,
    rx: 2
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F12F1F",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DE2010",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "flags-/-ZW",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#FFFFFF",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2",
    fill: "#369D0C",
    mask: "url(#mask-2)",
    x: 0,
    y: 0,
    width: 28,
    height: 2.66666667
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2",
    fill: "#369D0C",
    mask: "url(#mask-2)",
    x: 0,
    y: 17.3333333,
    width: 28,
    height: 2.66666667
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2",
    fill: "#369D0C",
    mask: "url(#mask-2)",
    x: 0,
    y: 5.33333333,
    width: 28,
    height: 2.66666667
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2",
    fill: "#369D0C",
    mask: "url(#mask-2)",
    x: 0,
    y: 12,
    width: 28,
    height: 2.66666667
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2",
    fill: "#262626",
    mask: "url(#mask-2)",
    x: 0,
    y: 8,
    width: 28,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2",
    fill: "#FFD40E",
    mask: "url(#mask-2)",
    x: 0,
    y: 2.66666667,
    width: 28,
    height: 2.66666667
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2",
    fill: "#FFD40E",
    mask: "url(#mask-2)",
    x: 0,
    y: 14.6666667,
    width: 28,
    height: 2.66666667
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.666666667,0.666666667 L12.2222222,10 L-0.222222222,19.3333333 L-0.666666667,19.3333333 L-0.666666667,0.666666667 Z",
    id: "Rectangle-83",
    stroke: "#262626",
    strokeWidth: 1.33333333,
    fill: "#FFFFFF",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Star-8",
    fill: "url(#linearGradient-3)",
    mask: "url(#mask-2)",
    points: "4 11.3000001 2.04071583 12.6967233 2.76362648 10.4017221 0.829811612 8.96994335 3.23587914 8.94827787 4 6.66666667 4.76412086 8.94827787 7.17018839 8.96994335 5.23637352 10.4017221 5.95928417 12.6967233"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZw);
export default __webpack_public_path__ + "static/media/ZW.5a119760e1044d86f9679699db6f1f38.svg";
export { ForwardRef as ReactComponent };